function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWork = function SvgWork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M255.17,0c-48.619,0-88.031,39.412-88.031,88.031v35.594c5.884-5.454,14.253-8.418,22.424-7.326 v-4.387c0-3.487,2.978-6.242,6.43-5.98c34.035,2.445,68.673-8.37,94.863-25.479c2.445-1.598,5.682-1.2,7.669,0.935 c22.39,24.067,22.255,23.136,22.255,26.278v8.614c8.956-1.342,16.9,1.425,22.42,6.557V88.031C343.201,39.412,303.79,0,255.17,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M187.745,88.031c0-45.132,33.967-82.307,77.728-87.411C262.091,0.225,258.658,0,255.17,0 c-48.619,0-88.03,39.412-88.03,88.031v35.595c5.447-5.049,13.026-7.957,20.605-7.496V88.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0A479"
    },
    d: "M320.663,113.093v48.411c0,0.525-0.027,1.043-0.04,1.566c17.131,2.594,30.549-9.784,30.549-24.986 C351.172,122.851,337.743,110.533,320.663,113.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59770"
    },
    d: "M341.426,118.195c-5.412-4.188-12.677-6.314-20.763-5.102v48.411c0,0.525-0.027,1.043-0.04,1.566 c8.111,1.228,15.387-0.903,20.803-5.099V118.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0A479"
    },
    d: "M189.76,161.563v-48.515c-14.953-1.997-30.587,9.479-30.587,25.035 c0,15.221,13.422,27.653,30.625,25.049C189.786,162.609,189.76,162.087,189.76,161.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59770"
    },
    d: "M189.76,158.19c-6.167-4.674-9.982-11.993-9.982-20.107c0-7.908,4.045-14.757,9.982-19.322v-5.713 c-14.953-1.997-30.587,9.479-30.587,25.035c0,15.221,13.422,27.653,30.625,25.05c-0.013-0.524-0.038-1.045-0.038-1.57V158.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0A479"
    },
    d: "M256.109,222.994c-14.222,0-26.72-3.904-36.943-10.436v36.065l36.784,45.404l36.784-45.404v-37.039 C282.314,218.772,269.697,222.994,256.109,222.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59770"
    },
    d: "M240.171,221.253c-7.756-1.743-14.802-4.731-21.005-8.695v36.065l21.005,25.928V221.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M390.045,283.219l-97.311-37.686l-36.784,45.404l-36.784-45.404l-97.209,37.686 c0,0-35.992,14.796-35.992,55.826c0,37.126,0,130.97,0,160.962c0,6.623,5.37,11.993,11.993,11.993c5.047,0,310.96,0,316.085,0 c6.623,0,11.993-5.37,11.993-11.993c0-29.992,0-123.836,0-160.962C426.037,298.015,390.045,283.219,390.045,283.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M106.499,500.007c0-29.992,0-135.169,0-172.294c0-23.8,12.106-38.758,22.277-47.137l-6.819,2.644 c0,0-35.992,14.796-35.992,55.826c0,37.126,0,130.97,0,160.962c0,6.623,5.37,11.993,11.993,11.993c0.757,0,8.28,0,20.533,0 C111.869,512,106.499,506.63,106.499,500.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0A479"
    },
    d: "M298.526,78.298c-1.987-2.136-5.225-2.533-7.67-0.935c-26.189,17.109-60.827,27.924-94.863,25.479 c-3.452-0.262-6.43,2.493-6.43,5.98v52.591c0,33.8,26.484,64.672,66.545,64.672c35.661,0,64.673-29.012,64.673-64.672v-56.836 C320.781,101.434,320.916,102.365,298.526,78.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59770"
    },
    d: "M210.169,161.413v-58.309c-4.721,0.153-9.453,0.077-14.175-0.262c-3.452-0.261-6.43,2.493-6.43,5.98 v52.591c0,33.8,26.484,64.672,66.545,64.672c3.181,0,6.307-0.241,9.366-0.687C234.238,220.845,210.169,193.891,210.169,161.413z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M154.949,512V353.147c0-4.267-3.459-7.727-7.727-7.727s-7.727,3.459-7.727,7.727V512 C144.337,512,149.504,512,154.949,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M372.509,512V353.147c0-4.267-3.459-7.727-7.727-7.727s-7.727,3.459-7.727,7.727V512 C362.5,512,367.666,512,372.509,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M300.364,314.267l27.507-55.127l-35.137-13.608l-36.784,45.404l35.863,25.47 C294.716,318.469,298.774,317.454,300.364,314.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M211.587,314.267L184.08,259.14l35.137-13.608l36.784,45.405l-35.863,25.47 C217.235,318.469,213.177,317.454,211.587,314.267z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M293.361,467.456l-23.609-139.743h-13.755h-0.044h-13.755l-23.609,139.743 c-0.248,1.8,0.28,3.628,1.406,4.869l0,0l0,0l32.594,35.923c1.816,2.001,4.957,2.001,6.773,0l32.594-35.923l0,0l0,0 C293.081,471.084,293.609,469.256,293.361,467.456z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED3A3A"
    },
    points: "255.998,290.968 255.998,290.937 255.976,290.953 255.953,290.937 255.953,290.968  229.869,309.494 242.199,328.051 255.953,328.051 255.998,328.051 269.752,328.051 282.082,309.494  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED3A3A"
    },
    d: "M240.601,472.325c-1.126-1.241-1.654-3.069-1.406-4.869l23.608-139.743h-6.806h-0.045h-13.755 l-23.608,139.743c-0.248,1.8,0.28,3.628,1.406,4.869l32.593,35.923c1.816,2.001,4.957,2.001,6.773,0l6.916-7.622L240.601,472.325z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2A2A"
    },
    d: "M266.278,298.27l-10.28-7.301v-0.032l-0.022,0.016l-0.022-0.016v0.032l-26.084,18.525l12.33,18.557 h13.755H256h6.806l-10.681-16.075c-0.919-1.383-0.573-3.246,0.78-4.207L266.278,298.27z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/work.02d8e087.svg";
export { ForwardRef as ReactComponent };